fragment ExerciseFragment on exercise_Entry {
  typeHandle
  exerciseObjectId
  heading
  description
  title: exerciseTitle
  shortDescription
  longDescription
  practiceLabelKey
  practiceValue
}
